import { Toggle, Tooltip } from '@ttab/elephant-ui'
import { Building2Icon } from '@ttab/elephant-ui/icons'
import { cn } from '@ttab/elephant-ui/utils'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Switches who the byline credits, the authors or the organisation. Lives at
 * the end of the byline pill, so the setting sits next to what it changes.
 */
export const BylineCreditToggle = ({ organisation, pressed, onPressedChange }: {
  organisation: string
  pressed: boolean
  onPressedChange: (pressed: boolean) => void
}): JSX.Element => {
  const { t } = useTranslation('metaSheet')
  const label = pressed
    ? t('bylineCredit.creditAuthors')
    : t('bylineCredit.creditOrganisation', { organisation })

  return (
    <Tooltip content={label}>
      <Toggle
        size='xs'
        aria-label={label}
        pressed={pressed}
        onPressedChange={onPressedChange}
        // A lone toggle has no neighbour to compare with, so pressed needs to
        // read on its own: filled with the primary colour, not a faint tint.
        className={cn(
          '-me-1.5 text-muted-foreground',
          'data-[pressed]:bg-primary data-[pressed]:text-primary-foreground',
          'data-[pressed]:hover:bg-primary/90 data-[pressed]:hover:text-primary-foreground'
        )}
      >
        <Building2Icon strokeWidth={1.75} />
      </Toggle>
    </Tooltip>
  )
}
